export default __webpack_public_path__ + "static/media/navbar-barred-list-dark.ad655d94.svg";